export const SAVE_DRIVER_MASTER = "SAVE_DRIVER_MASTER"
export const SAVE_DRIVER_MASTER_SUCCESS = "SAVE_DRIVER_MASTER_SUCCESS"

export const GET_DRIVER_LIST = "GET_DRIVER_LIST"
export const GET_DRIVER_LIST_SUCCESS = "GET_DRIVER_LIST_SUCCESS"

export const EDIT_DRIVER_TYPE_ID = "EDIT_DRIVER_TYPE_ID"
export const EDIT_DRIVER_TYPE_ID_SUCCESS = "EDIT_DRIVER_TYPE_ID_SUCCESS"

export const UPDATE_DRIVER_TYPE_ID = "UPDATE_DRIVER_TYPE_ID"
export const UPDATE_DRIVER_TYPE_ID_SUCCESS = "UPDATE_DRIVER_TYPE_ID_SUCCESS"

export const DELETE_DRIVER_TYPE_ID = "DELETE_DRIVER_TYPE_ID"
export const DELETE_DRIVER_TYPE_ID_SUCCESS = "DELETE_DRIVER_TYPE_ID_SUCCESS"


export const DRIVER_API_ERROR_ACTION = "DRIVER_API_ERROR_ACTION"


